export default __webpack_public_path__ + "91c73bccca0a454c851735cd690d48db.png";